import './checkout_fields.css';

export interface EmbarkFieldCopy {
  readonly nameLabel: string;
  readonly surnameLabel: string;
}

export interface EmbarkFieldProps {
  name?: string;
  surname?: string;
  onChange: (patch: { boardingName?: string; boardingSurname?: string }) => void;
  /** Prefix for the input id/label associations — kept unique per traveler in
   *  the multi-traveler drawer. Absent ⇒ the original `pc-boarding-*` ids. */
  idPrefix?: string;
  copy: EmbarkFieldCopy;
}

/** Boarding name + surname exactly as printed on the ticket (flight-only). Each
 *  input emits an independent patch so the draft merges partial edits. */
export function EmbarkField({
  name,
  surname,
  onChange,
  idPrefix = '',
  copy,
}: Readonly<EmbarkFieldProps>) {
  const nameId = `${idPrefix}pc-boarding-name`;
  const surnameId = `${idPrefix}pc-boarding-surname`;
  return (
    <div className="ctc-traveler-row">
      <div className="ctc-field">
        <label className="ctc-field-label" htmlFor={nameId}>
          {copy.nameLabel}
        </label>
        <input
          id={nameId}
          type="text"
          className="ctc-input"
          value={name ?? ''}
          onChange={(e) => {
            onChange({ boardingName: e.target.value });
          }}
          aria-label={copy.nameLabel}
        />
      </div>
      <div className="ctc-field">
        <label className="ctc-field-label" htmlFor={surnameId}>
          {copy.surnameLabel}
        </label>
        <input
          id={surnameId}
          type="text"
          className="ctc-input"
          value={surname ?? ''}
          onChange={(e) => {
            onChange({ boardingSurname: e.target.value });
          }}
          aria-label={copy.surnameLabel}
        />
      </div>
    </div>
  );
}
